import React from 'react'

// Libraries
import { Col, Container, Navbar, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { m } from 'framer-motion'

// Components
import Buttons from '../../Components/Button/Buttons'
import { Header, HeaderCart, HeaderLanguage, HeaderNav, Menu, SearchBar } from "../../Components/Header/Header";
import FooterStyle01 from '../../Components/Footers/FooterStyle01';
import { fadeIn } from "../../Functions/GlobalAnimations";
import { InputField } from "../../Functions/Utilities";
import SideButtons from "../../Components/SideButtons";

// Data
const cartData = [
  {
    img: "https://via.placeholder.com/600x765",
    productName: "Burberry London",
    size: "L",
    price: "$350.00",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/600x765",
    productName: "Down Bomber",
    size: "L",
    price: "$10.00",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/600x765",
    productName: "Down Bomber",
    size: "L",
    price: "$299.00",
    link: "#",
  },
]

const ShoppingCart = (props) => {
  InputField(1);
  return (
    <div style={props.style}>
      {/* Header Start */}
      <Header topSpace={{ desktop: true }} type="reverse-scroll">
        <HeaderNav fluid="fluid" theme="light" bg="white" menu="light" className="px-[35px] py-[0px] md:px-0" containerClass="sm:px-0">
          <Col className="col-auto col-sm-6 col-lg-2 me-auto ps-lg-0">
            <Link aria-label="header logo" className="flex items-center" to="/">
              <Navbar.Brand className="inline-block p-0 m-0">
                <img className="default-logo" width="111" height="36" loading="lazy" src='/assets/img/webp/logo-fast-blue-black.webp' data-rjs='/assets/img/webp/logo-fast-blue-black@2x.webp' alt='logo' />
                <img className="alt-logo" width="111" height="36" loading="lazy" src='/assets/img/webp/logo-fast-blue-black.webp' data-rjs='/assets/img/webp/logo-fast-blue-black@2x.webp' alt='logo' />
                <img className="mobile-logo" width="111" height="36" loading="lazy" src='/assets/img/webp/logo-fast-blue-black.webp' data-rjs='/assets/img/webp/logo-fast-blue-black@2x.webp' alt='logo' />
              </Navbar.Brand>
            </Link>
          </Col>
          <div className="col-auto hidden order-last md:block">
            <Navbar.Toggle className="md:ml-[10px] sm:ml-0">
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse className="col-auto px-0 justify-end">
            <Menu {...props} />
          </Navbar.Collapse>
          <Col className="col-auto text-right pe-0 !pl-[12px]">
            <SearchBar className="pr-0 xs:p-0" />
            <HeaderLanguage />
            <HeaderCart style={{ "--base-color": "#0038e3" }} />
          </Col>
        </HeaderNav>
      </Header>
      {/* Header End */}
      <SideButtons />
      {/* Section Start */}
      <section className="bg-lightgray py-[25px]">
        <Container>
          <Row className="items-center justify-center">
            <Col xl={8} lg={6}>
              <h1 className="font-serif text-darkgray font-medium mb-0 text-lg leading-[20px] md:text-center">Shopping cart</h1>
            </Col>
            <Col xl={4} lg={6} className="breadcrumb mb-0 justify-end font-serif md:justify-center">
              <ul className="xs-text-center">
                <li><Link aria-label="homepage" to="/">Home</Link></li>
                <li className="!leading-[22px]">Shop</li>
                <li className="!leading-[22px]">Shopping cart</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Section End */}

      {/* Section Start */}
      <m.section className="py-[130px] lg:py-[90px] sm:py-[75px] xs:py-[50px]" {...fadeIn}>
        <Container>
          <Row>
            <Col lg={8} className="pr-[70px] lg:pr-[30px] md:pr-[15px]">
              <Row>
                <Col xs={12} className="mb-[47px] md:mb-0">
                  <table className="cart-products  mb-[60px] md:mb-[40px] xs:!mb-0">
                    <thead>
                      <tr className="font-serif text-[#212529] text-start">
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th scope="col">Product</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        cartData.map((item, i) => {
                          return (
                            <tr key={i} className="product">
                              <td className="product-remove">
                                <span rel="noreferrer" className="btn-default text-lg cursor-pointer hover:text-basecolor">×</span>
                              </td>
                              <td className="product-thumbnail"><Link aria-label="product" to={item.link}><img className="cart-product-image" width="75" height="95.63" src={item.img} alt="product" /></Link></td>
                              <td className="product-name">
                                <a aria-label="shopping" href="/shop/single-product">{item.productName}</a>
                                <span className="variation"> Size: {item.size}</span>
                              </td>
                              <td className="product-price" data-title="Price">{item.price}</td>
                              <td className="product-quantity" data-title="Quantity">
                                <div className="quantity">
                                  <label className="screen-reader-text">Quantity</label>
                                  <input type="button" defaultValue="-" className="qty-minus qty-btn" />
                                  <input className="input-text qty-text" type="number" name="quantity" />
                                  <input type="button" defaultValue="+" className="qty-plus qty-btn" />
                                </div>
                              </td>
                              <td className="product-subtotal" data-title="Total">{item.price}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </Col>
                <Col md={6} className="md:mb-[50px] sm:mb-[20px]">
                  <div className="coupon-code-panel">
                    <input type="text" placeholder="Coupon code" className="relative" />
                    <i className="feather-scissors absolute left-5 leading-[44px]"></i>
                    <a aria-label="shopping" href="/shop/shopping-cart" className="btn apply-coupon-btn text-uppercase border-hidden">Apply</a>
                  </div>
                </Col>
                <Col md={6} className="flex justify-end md:items-center md:mb-[50px] sm:justify-center">
                  <Buttons ariaLabel="cart" href="/shop/shopping-cart" className="btn-fancy font-medium font-serif uppercase border-[2px] border-[#dbdbdb] rounded-none mr-[24px] bg-[#fff]" color="#000" size="sm" themeColor="#212529" title="Empty Cart" />
                  <Buttons ariaLabel="cart" href="/shop/shopping-cart" className="btn-fancy font-medium font-serif uppercase border-[2px] border-[#dbdbdb] rounded-none bg-[#fff]" color="#000" size="sm" themeColor="#212529" title="Update Cart" />
                </Col>
              </Row>
            </Col>
            <Col lg={4}>
              <div className="bg-lightgray p-[50px] lg:py-[30px] lg:px-[20px] md:py-5">
                <span className="font-serif text-lg text-darkgray mb-[15px] inline-block font-medium">Cart totals</span>
                <table className="w-full total-price-table">
                  <tbody>
                    <tr>
                      <th className="w-1/2 font-medium text-darkgray">Subtotal</th>
                      <td className="text-darkgray md:text-right">$405.00</td>
                    </tr>
                    <tr className="shipping">
                      <th className="font-medium text-darkgray">Shipping</th>
                      <td data-title="Shipping" className="flex justify-start md:justify-end">
                        <ul className="lg:float-start float-end text-start leading-9">
                          <li className="flex items-center md:mb-[15px]">
                            <input id="free_shipping" type="radio" name="shipping-option" className="block w-auto mr-[10px] mb-0" defaultChecked="checked" />
                            <label className="leading-[36px] md:leading-[18px]" htmlFor="free_shipping">Free shipping</label>
                          </li>
                          <li className="flex items-center md:mb-[15px]">
                            <input id="flat" type="radio" name="shipping-option" className="block w-auto mr-[10px] mb-0" />
                            <label className="leading-[36px] md:leading-[18px]" htmlFor="flat">Flat: $12.00</label>
                          </li>
                          <li className="flex items-center">
                            <input id="local_pickup" type="radio" name="shipping-option" className="block w-auto mr-[10px] mb-0" />
                            <label className="leading-[36px] md:leading-[18px]" htmlFor="local_pickup">Local pickup</label>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr className="calculate-shipping">
                      <th colSpan="2" className="font-medium relative">
                        <a className="flex items-center" data-bs-toggle="collapse" href="#shipping-accordion" aria-expanded="false">
                          <i className="feather-chevron-down absolute right-0 text-darkgray font-bold"></i>
                          <p className="w-full mb-0 text-start text-darkgray">Calculate shipping</p>
                        </a>
                        <div>
                          <div id="shipping-accordion" className="cart-dropdown collapse mt-[15px]">
                            <select className="py-[10px] px-[15px] w-full border border-[#dfdfdf]">
                              <option className="font-normal">Select a Country...</option>
                              <option value="Afganistan">Afghanistan</option>
                              <option value="Albania">Albania</option>
                              <option value="Algeria">Algeria</option>
                              <option value="American Samoa">American Samoa</option>
                              <option value="Andorra">Andorra</option>
                              <option value="Angola">Angola</option>
                              <option value="Anguilla">Anguilla</option>
                              <option value="Antigua &amp; Barbuda">Antigua &amp; Barbuda</option>
                              <option value="Argentina">Argentina</option>
                              <option value="Armenia">Armenia</option>
                              <option value="Aruba">Aruba</option>
                              <option value="Australia">Australia</option>
                              <option value="Austria">Austria</option>
                              <option value="Azerbaijan">Azerbaijan</option>
                              <option value="Bahamas">Bahamas</option>
                              <option value="Bahrain">Bahrain</option>
                              <option value="Bangladesh">Bangladesh</option>
                              <option value="Barbados">Barbados</option>
                              <option value="Belarus">Belarus</option>
                              <option value="Belgium">Belgium</option>
                              <option value="Belize">Belize</option>
                              <option value="Benin">Benin</option>
                              <option value="Bermuda">Bermuda</option>
                              <option value="Bhutan">Bhutan</option>
                              <option value="Bolivia">Bolivia</option>
                              <option value="Bonaire">Bonaire</option>
                              <option value="Bosnia &amp; Herzegovina">Bosnia &amp; Herzegovina</option>
                              <option value="Botswana">Botswana</option>
                              <option value="Brazil">Brazil</option>
                              <option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
                              <option value="Brunei">Brunei</option>
                              <option value="Bulgaria">Bulgaria</option>
                              <option value="Burkina Faso">Burkina Faso</option>
                              <option value="Burundi">Burundi</option>
                              <option value="Cambodia">Cambodia</option>
                              <option value="Cameroon">Cameroon</option>
                              <option value="Canada">Canada</option>
                              <option value="Canary Islands">Canary Islands</option>
                              <option value="Cape Verde">Cape Verde</option>
                              <option value="Cayman Islands">Cayman Islands</option>
                              <option value="Central African Republic">Central African Republic</option>
                              <option value="Chad">Chad</option>
                              <option value="Channel Islands">Channel Islands</option>
                              <option value="Chile">Chile</option>
                              <option value="China">China</option>
                              <option value="Christmas Island">Christmas Island</option>
                              <option value="Cocos Island">Cocos Island</option>
                              <option value="Colombia">Colombia</option>
                              <option value="Comoros">Comoros</option>
                              <option value="Congo">Congo</option>
                              <option value="Cook Islands">Cook Islands</option>
                              <option value="Costa Rica">Costa Rica</option>
                              <option value="Cote DIvoire">Cote DIvoire</option>
                              <option value="Croatia">Croatia</option>
                              <option value="Cuba">Cuba</option>
                              <option value="Curaco">Curacao</option>
                              <option value="Cyprus">Cyprus</option>
                              <option value="Czech Republic">Czech Republic</option>
                              <option value="Denmark">Denmark</option>
                              <option value="Djibouti">Djibouti</option>
                              <option value="Dominica">Dominica</option>
                              <option value="Dominican Republic">Dominican Republic</option>
                              <option value="East Timor">East Timor</option>
                              <option value="Ecuador">Ecuador</option>
                              <option value="Egypt">Egypt</option>
                              <option value="El Salvador">El Salvador</option>
                              <option value="Equatorial Guinea">Equatorial Guinea</option>
                              <option value="Eritrea">Eritrea</option>
                              <option value="Estonia">Estonia</option>
                              <option value="Ethiopia">Ethiopia</option>
                              <option value="Falkland Islands">Falkland Islands</option>
                              <option value="Faroe Islands">Faroe Islands</option>
                              <option value="Fiji">Fiji</option>
                              <option value="Finland">Finland</option>
                              <option value="France">France</option>
                              <option value="French Guiana">French Guiana</option>
                              <option value="French Polynesia">French Polynesia</option>
                              <option value="French Southern Ter">French Southern Ter</option>
                              <option value="Gabon">Gabon</option>
                              <option value="Gambia">Gambia</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Germany">Germany</option>
                              <option value="Ghana">Ghana</option>
                              <option value="Gibraltar">Gibraltar</option>
                              <option value="Great Britain">Great Britain</option>
                              <option value="Greece">Greece</option>
                              <option value="Greenland">Greenland</option>
                              <option value="Grenada">Grenada</option>
                              <option value="Guadeloupe">Guadeloupe</option>
                              <option value="Guam">Guam</option>
                              <option value="Guatemala">Guatemala</option>
                              <option value="Guinea">Guinea</option>
                              <option value="Guyana">Guyana</option>
                              <option value="Haiti">Haiti</option>
                              <option value="Hawaii">Hawaii</option>
                              <option value="Honduras">Honduras</option>
                              <option value="Hong Kong">Hong Kong</option>
                              <option value="Hungary">Hungary</option>
                              <option value="Iceland">Iceland</option>
                              <option value="Indonesia">Indonesia</option>
                              <option value="India">India</option>
                              <option value="Iran">Iran</option>
                              <option value="Iraq">Iraq</option>
                              <option value="Ireland">Ireland</option>
                              <option value="Isle of Man">Isle of Man</option>
                              <option value="Israel">Israel</option>
                              <option value="Italy">Italy</option>
                              <option value="Jamaica">Jamaica</option>
                              <option value="Japan">Japan</option>
                              <option value="Jordan">Jordan</option>
                              <option value="Kazakhstan">Kazakhstan</option>
                              <option value="Kenya">Kenya</option>
                              <option value="Kiribati">Kiribati</option>
                              <option value="Korea North">Korea North</option>
                              <option value="Korea Sout">Korea South</option>
                              <option value="Kuwait">Kuwait</option>
                              <option value="Kyrgyzstan">Kyrgyzstan</option>
                              <option value="Laos">Laos</option>
                              <option value="Latvia">Latvia</option>
                              <option value="Lebanon">Lebanon</option>
                              <option value="Lesotho">Lesotho</option>
                              <option value="Liberia">Liberia</option>
                              <option value="Libya">Libya</option>
                              <option value="Liechtenstein">Liechtenstein</option>
                              <option value="Lithuania">Lithuania</option>
                              <option value="Luxembourg">Luxembourg</option>
                              <option value="Macau">Macau</option>
                              <option value="Macedonia">Macedonia</option>
                              <option value="Madagascar">Madagascar</option>
                              <option value="Malaysia">Malaysia</option>
                              <option value="Malawi">Malawi</option>
                              <option value="Maldives">Maldives</option>
                              <option value="Mali">Mali</option>
                              <option value="Malta">Malta</option>
                              <option value="Marshall Islands">Marshall Islands</option>
                              <option value="Martinique">Martinique</option>
                              <option value="Mauritania">Mauritania</option>
                              <option value="Mauritius">Mauritius</option>
                              <option value="Mayotte">Mayotte</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Midway Islands">Midway Islands</option>
                              <option value="Moldova">Moldova</option>
                              <option value="Monaco">Monaco</option>
                              <option value="Mongolia">Mongolia</option>
                              <option value="Montserrat">Montserrat</option>
                              <option value="Morocco">Morocco</option>
                              <option value="Mozambique">Mozambique</option>
                              <option value="Myanmar">Myanmar</option>
                              <option value="Nambia">Nambia</option>
                              <option value="Nauru">Nauru</option>
                              <option value="Nepal">Nepal</option>
                              <option value="Netherland Antilles">Netherland Antilles</option>
                              <option value="Netherlands">Netherlands (Holland, Europe)</option>
                              <option value="Nevis">Nevis</option>
                              <option value="New Caledonia">New Caledonia</option>
                              <option value="New Zealand">New Zealand</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Niger">Niger</option>
                              <option value="Nigeria">Nigeria</option>
                              <option value="Niue">Niue</option>
                              <option value="Norfolk Island">Norfolk Island</option>
                              <option value="Norway">Norway</option>
                              <option value="Oman">Oman</option>
                              <option value="Pakistan">Pakistan</option>
                              <option value="Palau Island">Palau Island</option>
                              <option value="Palestine">Palestine</option>
                              <option value="Panama">Panama</option>
                              <option value="Papua New Guinea">Papua New Guinea</option>
                              <option value="Paraguay">Paraguay</option>
                              <option value="Peru">Peru</option>
                              <option value="Phillipines">Philippines</option>
                              <option value="Pitcairn Island">Pitcairn Island</option>
                              <option value="Poland">Poland</option>
                              <option value="Portugal">Portugal</option>
                              <option value="Puerto Rico">Puerto Rico</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Republic of Montenegro">Republic of Montenegro</option>
                              <option value="Republic of Serbia">Republic of Serbia</option>
                              <option value="Reunion">Reunion</option>
                              <option value="Romania">Romania</option>
                              <option value="Russia">Russia</option>
                              <option value="Rwanda">Rwanda</option>
                              <option value="St Barthelemy">St Barthelemy</option>
                              <option value="St Eustatius">St Eustatius</option>
                              <option value="St Helena">St Helena</option>
                              <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                              <option value="St Lucia">St Lucia</option>
                              <option value="St Maarten">St Maarten</option>
                              <option value="St Pierre &amp; Miquelon">St Pierre &amp; Miquelon</option>
                              <option value="St Vincent &amp; Grenadines">St Vincent &amp; Grenadines</option>
                              <option value="Saipan">Saipan</option>
                              <option value="Samoa">Samoa</option>
                              <option value="Samoa American">Samoa American</option>
                              <option value="San Marino">San Marino</option>
                              <option value="Sao Tome &amp; Principe">Sao Tome &amp; Principe</option>
                              <option value="Saudi Arabia">Saudi Arabia</option>
                              <option value="Senegal">Senegal</option>
                              <option value="Seychelles">Seychelles</option>
                              <option value="Sierra Leone">Sierra Leone</option>
                              <option value="Singapore">Singapore</option>
                              <option value="Slovakia">Slovakia</option>
                              <option value="Slovenia">Slovenia</option>
                              <option value="Solomon Islands">Solomon Islands</option>
                              <option value="Somalia">Somalia</option>
                              <option value="South Africa">South Africa</option>
                              <option value="Spain">Spain</option>
                              <option value="Sri Lanka">Sri Lanka</option>
                              <option value="Sudan">Sudan</option>
                              <option value="Suriname">Suriname</option>
                              <option value="Swaziland">Swaziland</option>
                              <option value="Sweden">Sweden</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="Syria">Syria</option>
                              <option value="Tahiti">Tahiti</option>
                              <option value="Taiwan">Taiwan</option>
                              <option value="Tajikistan">Tajikistan</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Thailand">Thailand</option>
                              <option value="Togo">Togo</option>
                              <option value="Tokelau">Tokelau</option>
                              <option value="Tonga">Tonga</option>
                              <option value="Trinidad &amp; Tobago">Trinidad &amp; Tobago</option>
                              <option value="Tunisia">Tunisia</option>
                              <option value="Turkey">Turkey</option>
                              <option value="Turkmenistan">Turkmenistan</option>
                              <option value="Turks &amp; Caicos Is">Turks &amp; Caicos Is</option>
                              <option value="Tuvalu">Tuvalu</option>
                              <option value="Uganda">Uganda</option>
                              <option value="United Kingdom">United Kingdom</option>
                              <option value="Ukraine">Ukraine</option>
                              <option value="United Arab Erimates">United Arab Emirates</option>
                              <option value="United States of America">United States of America</option>
                              <option value="Uraguay">Uruguay</option>
                              <option value="Uzbekistan">Uzbekistan</option>
                              <option value="Vanuatu">Vanuatu</option>
                              <option value="Vatican City State">Vatican City State</option>
                              <option value="Venezuela">Venezuela</option>
                              <option value="Vietnam">Vietnam</option>
                              <option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
                              <option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
                              <option value="Wake Island">Wake Island</option>
                              <option value="Wallis &amp; Futana Is">Wallis &amp; Futana Is</option>
                              <option value="Yemen">Yemen</option>
                              <option value="Zaire">Zaire</option>
                              <option value="Zambia">Zambia</option>
                              <option value="Zimbabwe">Zimbabwe</option>
                            </select>
                            <select className="py-[10px] px-[15px] mt-[15px] w-full border border-[#dfdfdf]">
                              <option className="font-normal">State</option>
                            </select>
                            <input type="text" name="city" placeholder="Town/City" className="py-[10px] px-[15px] my-[15px] w-full border border-[#dfdfdf]" />
                            <input type="text" name="zip" placeholder="ZIP" className="py-[10px] px-[15px] w-full border border-[#dfdfdf]" />
                            <Buttons ariaLabel="cart" href="/shop/shopping-cart" className="btn-fill font-medium font-serif rounded-none uppercase md:mb-[15px] block mt-[15px]" themeColor="#232323" color="#fff" size="sm" title="Update" />
                          </div>
                        </div>
                      </th>
                    </tr>
                    <tr className="total-amount">
                      <th className="font-medium text-darkgray">Total</th>
                      <td data-title="Total">
                        <h6 className="block font-sans font-medium mb-0 text-darkgray md:text-end">$405.00</h6>
                        <span className="text-sm leading-[15px] mt-[8px] text-[#757575] block md:text-end">(Includes $19.29 tax)</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="mt-[20px]">
                  <Buttons ariaLabel="cart" to="/shop/checkout" className="btn-fill tracking-[1px] font-medium font-serif rounded-none uppercase md:mb-[15px] !py-[13px] block" themeColor="#232323" color="#fff" size="lg" title="Proceed to checkout" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </m.section >
      {/* Section End */}

      {/* Footer Start */}
      <FooterStyle01 theme="dark" className="text-slateblue bg-[#262b35]" />
      {/* Footer End */}
    </div >
  )
}

export default ShoppingCart